module.exports = __webpack_public_path__ + "static/media/filimonova.9acf4171.jpg";